import { useEffect } from 'react';
import { PlayerRef } from '@remotion/player';
import { roundToNDecimalPlaces } from '@goldcast/player-config/src/utils/mathUtils';
import { setCurrentTimeWithoutSeeking } from '@/Pages/Clip/ClipPlayer/ClipNewTimeline/store/remotionPlayerState';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';

export const useRemotionTimeSync = ({
  playerRef,
  useTimeUpdate = false
}: {
  playerRef: PlayerRef | null;
  useTimeUpdate?: boolean;
}) => {
  const { fps } = useClipsContext();

  const isSmoothCuePointEnabled = !useTimeUpdate;

  useEffect(() => {
    if (playerRef) {
      const handleTimeUpdate = ({ detail: { frame } }: { detail: { frame: number } }) => {
        if (!playerRef.isPlaying()) {
          return;
        }
        setCurrentTimeWithoutSeeking(roundToNDecimalPlaces(frame / fps, 3));
      };
      playerRef.addEventListener(isSmoothCuePointEnabled ? 'frameupdate' : 'timeupdate', handleTimeUpdate);
      setCurrentTimeWithoutSeeking(roundToNDecimalPlaces(playerRef.getCurrentFrame() / fps, 3));

      return () => {
        playerRef.removeEventListener(isSmoothCuePointEnabled ? 'frameupdate' : 'timeupdate', handleTimeUpdate);
      };
    }
  }, [playerRef, isSmoothCuePointEnabled, fps]);
};
